import { Stack, Typography, Button } from '@mui/material';
import StepperDUC from '../duc/StepperDUC';
import { DownloadProcessSteps, stepLabels } from "./DataDownloadProcess";
import { colours } from '../../StyleConstants';
import Selector from './components/Selector';
import { useState } from 'react';


const FileSelection = (props: any) => {

    const dummyData = [
        { id: 1, title: props.info.release.split("-")[0] + "Minimally Processed Data. Recommended T1w", size: "0.00GB" },
        { id: 2, title: props.info.release.split("-")[0] + "Minimally Processed Data. Recommended T2w", size: "0.00GB" },
        { id: 3, title: props.info.release.split("-")[0] + "Minimally Processed Data. Recommended dMRI", size: "0.00GB" },
        { id: 4, title: props.info.release.split("-")[0] + "Minimally Processed Data. Recommended task fMRI (MID)", size: "0.00GB" },
        { id: 5, title: props.info.release.split("-")[0] + "Minimally Processed Data. Recommended task fMRI (SST)", size: "0.00GB" },
        { id: 6, title: props.info.release.split("-")[0] + "Minimally Processed Data. Recommended task fMRI (nBack)", size: "0.00GB" },
    ]

    const [selectedFiles, setSelectedFiles] = useState(() => new Set());
    const [selectedFilesID, setSelectedFilesID] = useState(() => new Set());
    const [deselectedFiles, setDeselectedFiles] = useState(() => new Set());

    const handleClickContinue = () => {
        props.setInfo({ ...props.info, selectedFiles: selectedFiles })
        props.setCurStep(DownloadProcessSteps.DownloadDetails);
    };

    const handleClickFile = ({ id, title, size }: {id: string, title: string, size: string}) => {
        
        if(selectedFilesID.has(id)){
            selectedFiles.forEach((file: any) => {
                if(file.id === id){
                    const newFiles = new Set(selectedFiles);
                    newFiles.delete(file)
                    setSelectedFiles(newFiles)
                    return
                }
                
            });

            const newFilesID = new Set(selectedFilesID);
            newFilesID.delete(id)
            setSelectedFilesID(newFilesID)

            setDeselectedFiles(deselectedFiles => new Set(deselectedFiles).add(id))

        }
        
        else{
            setSelectedFilesID(selectedFiles => new Set(selectedFiles).add(id))
            setSelectedFiles(selectedFiles => new Set(selectedFiles).add({ id, title, size }))
        }
    };

    const handleClickBack = () => {
        props.setCurStep(DownloadProcessSteps.DatasetSelection)
    }

    const handleMouseOut = (id: number) => {
        if(deselectedFiles.has(id)){
            const newFiles = new Set(deselectedFiles);
            newFiles.delete(id)
            setDeselectedFiles(newFiles)
        }
    }

    return (
        <Stack gap={3} sx={{ padding: 3 }}>
            <Stack flexDirection="column" gap={4} alignItems="center">
                <Typography
                    variant="h3"
                    fontWeight="600"
                    fontSize="40px"
                    textAlign="center"
                    color={colours.midnightBlue.blue}>
                    New Dataset Download
                </Typography>
                <StepperDUC
                    activeStep={DownloadProcessSteps.FileSelection}
                    stepLabels={stepLabels}
                />
            </Stack>

            <Button
                variant="tertiary"
                onClick={() => handleClickBack()}
                sx={{ width: "150px" }}
            >
                Back
            </Button>

            <Stack direction="row" gap={3} sx={{ marginTop: 3 }}>
                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected study
                    </Typography>
                    <Selector
                        title={props.info.study}
                        hover={false}
                        text="Information about the study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected release
                    </Typography>
                    <Selector
                        title={props.info.release}
                        hover={false}
                        text="Information about the study"/>
                </Stack>

                <Stack flex={1}>
                    <Typography variant="h6" fontWeight="600" color={colours.orange.orange}>
                        Selected dataset
                    </Typography>
                    <Selector
                        title={props.info.dataset}
                        hover={false}
                        text="Information about the study"/>
                </Stack>
            </Stack>

            <Stack>
                <Typography variant="h6" fontWeight="600" color={colours.midnightBlue.blue} sx={{ marginTop: 3 }}>
                    Select files
                </Typography>

                <Stack gap={2} maxHeight="400px"  sx={{ width: '100%' }} overflow="auto">
                    {dummyData.map((file) => (
                        <Selector
                            key={file.title}
                            title={file.title}
                            hover={!selectedFilesID.has(file.id)}
                            clickInfo={file}
                            handleClick={handleClickFile}
                            text={props.size}
                            skinny={true}
                            deselected = {deselectedFiles.has(file.id)}
                            onMouseOut = {handleMouseOut}
                            mouseOutInfo={file.id}
                        />
                    ))}
                </Stack>

                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ marginTop: 3 }}>
                    <Typography variant="body2" fontWeight="600" color={colours.midnightBlue.blue}>
                        {selectedFiles.size} files selected
                    </Typography>
                    <Button
                        variant="primary"
                        onClick={handleClickContinue}
                    >
                        Continue
                    </Button>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default FileSelection;